import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import { BaseApiRoutes, BaseApiGetters } from "@/modules/core/classes/Api";

import { Permission } from "@/modules/roles/viewmodels/Permission";

// state
export const state = {
  current: null,
};

export const getters = Object.assign(
  {
    current: (state) => {
      return state.current;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/permissions",
    Permission
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/permissions",
  [],
  {}
);
